import {ILayoutColumn, ILayoutRow} from '../_interface/layout';
import {MAX_COLUMNS_IN_LAYOUT} from 'shared/magic';
import {cloneDeep} from 'lodash-es';

export const vectorMoveField = (
	currentRows: ILayoutRow[],
	coords: {startColumn: number, endColumn: number, startRow: number, endRow: number}
): ILayoutRow[] => {
	const {startColumn, startRow, endColumn, endRow} = coords;
	const item = currentRows[startRow][startColumn];
	return clean(paste(nullAt(startRow, startColumn, fresh(currentRows)), item, endRow, endColumn));
};

export const vectorMoveFieldTo = (
	currentRows: ILayoutRow[],
	coords: {startColumn: number, startRow: number},
	first = true
): ILayoutRow[] => {
	const {startColumn, startRow} = coords;
	const pasteTo = first ? pasteFirst : pasteLast;
	const item = currentRows[startRow][startColumn];
	return clean(pasteTo(nullAt(startRow, startColumn, fresh(currentRows)), item));
};

export const addFieldInLayout = (
	currentRows: ILayoutRow[],
	coords: {column: number, row: number},
	item: ILayoutColumn
): ILayoutRow[] => {
	const {column, row} = coords;
	return paste(fresh(currentRows), item, row, column);
};

export const addFieldInLayoutAtStartOrEnd = (
	currentRows: ILayoutRow[],
	item: ILayoutColumn,
	beginning = true
): ILayoutRow[] => {
	const pasteTo = beginning ? pasteFirst : pasteLast;
	return pasteTo(fresh(currentRows), {...item, size: MAX_COLUMNS_IN_LAYOUT});
};

export const removeFieldInLayoutAt = (
	currentRows: ILayoutRow[],
	coords: { row: number, column: number },
): ILayoutRow[] => {
	const {row, column} = coords;
	return clean(nullAt(row, column, fresh(currentRows)));
};

export const nullAt = (row: number, column: number, rows: ILayoutRow[]): ILayoutRow[] => {
	rows[row][column] = null;
	return rows;
};

export const fresh = (arr: ILayoutRow[]): ILayoutRow[] => cloneDeep(arr);

export const clean = (arr: ILayoutRow[]): ILayoutRow[] => arr
	.map(row => row.filter(Boolean))
	.filter(f => f.length);

export const paste = (rows: ILayoutRow[], pasteElement: ILayoutColumn, row: number, column: number): ILayoutRow[] => {
	rows[row].splice(column, 0, pasteElement);
	return rows;
};

export const pasteFirst = (arr: ILayoutRow[], i: ILayoutColumn): ILayoutRow[] => {
	return [[i], ...arr];
};

export const pasteLast = (rows: ILayoutRow[], column: ILayoutColumn): ILayoutRow[] => {
	return [...rows, [column]];
};
